export {getAuthorizedRegions} from './getAuthorizedRegions';
export {default as registerServiceWorker} from './registerServiceWorker';



// WEBPACK FOOTER //
// ./src/utils/index.ts